var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccountActive = function SvgAccountActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 5,
    fill: "#3B7CC9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#68ADFF",
    d: "M3 18a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v3H3v-3Z"
  })));
};
export default SvgAccountActive;